import * as React from 'react';
import { DialogContent } from '@design-system/Dialog';
import { cn } from '@/utils/styles';

const SMP_DIALOG_CLASS =
  'flex flex-col items-stretch pt-8 pb-6 px-6 gap-6';

export const SMPDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogContent>,
  React.ComponentPropsWithoutRef<typeof DialogContent>
>(({ className, ...props }, ref) => (
  <DialogContent ref={ref} className={cn(SMP_DIALOG_CLASS, className)} {...props} />
));
SMPDialogContent.displayName = 'SMPDialogContent';
